import { ActionLink } from '@/components/ActionLink/ActionLink';
import { Notification } from '@/components/Notification/Notification';
import { NotificationWrapperPropsType } from '@/components/Notification/styles';
import { envConfig } from '@/config/envConfig';
import { CONTACT_MOBILE_PHONE, FORMATTED_CONTACT_MOBILE_PHONE } from '@/const/shared';

type ErrorSupportNotificationType = NotificationWrapperPropsType;

export const ErrorSupportNotification = (props: ErrorSupportNotificationType) => {
  return (
    <Notification variant='error' fontVariant='semibold' {...props}>
      Something went wrong. Please contact{' '}
      <ActionLink href={envConfig.SUPPORT_EMAIL_URL}>{envConfig.SUPPORT_EMAIL_URL}</ActionLink> or{' '}
      <ActionLink href={CONTACT_MOBILE_PHONE} type='tel'>
        {FORMATTED_CONTACT_MOBILE_PHONE}
      </ActionLink>
    </Notification>
  );
};
